
function toThousands(num) {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}

function hashCode(s) {
    let hash = 0, i, chr;
    if (s.length === 0) return hash;
    for (i = 0; i < s.length; i++) {
        chr = s.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
}

function isEmpty(s) {
    return s === undefined || s === null || s === '';
}

function ifEmpty(s, e) {
    return isEmpty(s) ? e : s;
}

function isNotEmpty(s) { return !isEmpty(s); }

const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;
const TB = GB * 1024;
const PB = TB * 1024;
const ZB = PB * 1024;

function getSpaceSizeUnit(sizeInBytes) {
    if (sizeInBytes === null || sizeInBytes === undefined) {
        return sizeInBytes;
    }
    if (sizeInBytes >= TB) {
        return {value: (sizeInBytes / TB).toFixed(2), unit: 'TB'};
    }
    if (sizeInBytes >= GB) {
        return {value: (sizeInBytes / GB).toFixed(2), unit: 'GB'};
    }
    if (sizeInBytes >= MB) {
        return {value: (sizeInBytes / MB).toFixed(2), unit: 'MB'};
    }
    if (sizeInBytes >= KB) {
        return {value: (sizeInBytes / KB).toFixed(2), unit: 'KB'};
    }
    return {value: sizeInBytes, unit: 'B'};
}

function formatSpaceSize(sizeInBytes) {
    if (sizeInBytes === null || sizeInBytes === undefined) {
        return sizeInBytes;
    }
    const rv = getSpaceSizeUnit(sizeInBytes);
    return `${rv.value}${rv.unit}`;
}

const storageVersionAreas = {
// 1.0主题域：
// 商品域: DW_Item_D_*
// 课程域: DW_Course_D_*
// 会员域: DW_Vip_D_*
// 交易域: DW_Transaction_F_*
// 财务域: DW_Finance_D_*
//        DW_Finance_F_*
// 组织域: DW_Orgaization_D_*
// 用户域: DW_User_D_*
// 产品域: DW_Application_D_*
//        DW_Application_F_*
    'CDW 1.0': [
        {
            title: '商品',
            key: '商品域',
        }, {
            title: '课程',
            key: '课程域',
        }, {
            title: '会员',
            key: '会员域',
        }, {
            title: '交易',
            key: '交易域',
        }, {
            title: '财务',
            key: '财务域',
        }, {
            title: '组织',
            key: '组织域',
        }, {
            title: '用户',
            key: '用户域',
        }, {
            title: '产品',
            key: '产品域',
        }
    ],
// 用户域: 维度表 dim_user_*
// 	   事实表 dwd_user_*
// 用户流量域: 暂无表
// 交易域: 维度表 dim_trade_*
//        事实表 dwd_mall_trade_*
// 库存域: 维度表 dim_stock_*
//        事实表 
// 课程域:暂无
// 兑换域:暂无
// 日期域: 维度表 dim_pub_date_*
// 产品域: 维度表 dim_product_*
// 教师域: 暂无
// 设备域: 暂无
// 位置域: 维度表 dim_area_*
// 广告域: 维度表 dim_ad_*
// 平台域: 暂无
    'CDW 2.0': [
        {
            title: '用户',
            key: '用户域',
        }, {
            title: '流量',
            key: '流量域',
        }, {
            title: '交易',
            key: '交易域',
        }, {
            title: '财务',
            key: '财务域',
        }, {
            title: '库存',
            key: '库存域',
        }, {
            title: '课程',
            key: '课程域',
        }, {
            title: '兑换',
            key: '兑换域',
        }, {
            title: '日期',
            key: '日期域',
        }, {
            title: '产品',
            key: '产品域',
        }, {
            title: '教师',
            key: '教师域',
        }, {
            title: '设备',
            key: '设备域',
        }, {
            title: '位置',
            key: '位置域',
        }, {
            title: '广告',
            key: '广告域',
        }, {
            title: '平台',
            key: '平台域',
        }, {
            title: '物流',
            key: '物流域',
        }, {
            title: '组织',
            key: '组织域',
        }, {
            title: '营销',
            key: '营销域',
        }, 
    ],
    'dataStorage': [
        {
            title: '用户',
            key: '用户域',
        }, {
            title: '流量',
            key: '流量域',
        }, {
            title: '交易',
            key: '交易域',
        }, {
            title: '学习',
            key: '学习域',
        },  {
            title: '物流',
            key: '物流域',
        }, {
            title: '库存',
            key: '库存域',
        },{
            title: '财务',
            key: '财务域',
        }, {
            title: '兑换',
            key: '兑换域',
        }, {
            title: '营销',
            key: '营销域',
        }, 
    ]
}

const storageFlattenAreas = (() => {
    const unique = new Set();
    const areas = [];
    for (let key of Object.keys(storageVersionAreas)) {
        for (let item of storageVersionAreas[key]) {
            if (unique.has(item.key)) {
                continue;
            }
            unique.add(item.key);
            areas.push(item);
        }
    }
    storageVersionAreas.ODS = areas;
    storageVersionAreas.all = areas;
    return areas;
})();


const storageBus = [
    { key: 'MIS', title: 'MIS' },
    { key: '夜曲编程', title: '夜曲编程' },
    { key: '履约', title: '履约' },
    { key: '柚子鸭', title: '柚子鸭' },
    { key: '爱阅读', title: '爱阅读' },
    { key: '电商私域', title: '电商私域' },
    { key: '番茄英语', title: '番茄英语' },
    { key: '百词斩', title: '百词斩' },
    { key: '芝士派', title: '芝士派' },
    { key: '薄荷阅读', title: '薄荷阅读' },
    { key: '蛋糕英语', title: '蛋糕英语' },
    { key: 'CRM', title: 'CRM' },
    { key: '咸蛋英语', title: '咸蛋英语' },
    { key: '广告平台', title: '广告平台' },
    { key: '舆情监控', title: '舆情监控' },
    { key: '课程平台', title: '课程平台' },
];

const storageMarket = [
    { key: '薄芝数据集市', title: '薄芝数据集市' },
    { key: '未来技能数据集市', title: '未来技能数据集市' },
    { key: 'CRM数据集市', title: 'CRM数据集市' },
    { key: '广告数据集市', title: '广告数据集市' },
];

const storageLevels = [
    { key: 'ODS', title: 'ODS' },
    { key: 'DW', title: 'DW' },
    { key: 'DWD', title: 'DWD' },
    { key: 'DWS', title: 'DWS' },
    { key: 'DM', title: 'DM' },
    { key: 'ADS', title: 'ADS' },
    { key: 'DIM', title: 'DIM' },
];

const storageTableExtraInfos = {
    ARCHIVED: { title: '归档', color: '#262626' },
    EXTERNAL: { title: '外部表', color: '#52c41a' },
    PARTITION: { title: '分区表', color: '#f50' },
    TRANSACTIONAL: { title: '事务表', color: '#096dd9' },
    VIRTUAL_VIEW: { title: '虚拟视图', color: '#c41d7f' },
};

const storageSpaceSizeColors = {
    B: '#434343',
    KB: '#389e0d',
    MB: '#096dd9',
    GB: '#d4380d',
    TB: '#f5222d',
};

const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DD';

const projects = [
    { value: 'mint_pie', title: '薄荷芝士派',
        children: [
            { value: 'mint_gzh', title: '薄荷公众号' },
            { value: 'cheesepie_gzh', title: '芝士派公众号' },
            { value: 'egg_gzh', title: '咸蛋公众号' },
            { value: 'tomato_gzh', title: '番茄公众号' },
            { value: 'cheezeup_gzh', title: '芝士小考公众号' },
            { value: 'cet_gzh', title: '斩家四六级公众号' },
            { value: 'bcz_listening_gzh', title: '百词斩听力公众号' },
            { value: 'mint_camp_gzh', title: '薄荷英语活动营公众号' },
            { value: 'danny_listening_gzh', title: '丹尼每日听力公众号' },
            { value: 'danny_reading_gzh', title: '丹尼早晚安公众号' },
            { value: 'danny_talking_gzh', title: '丹尼每日口语公众号' },
            { value: 'danny_cet_gzh', title: '（丹尼）百词斩四六级公众号' },
            { value: 'mint_store_gzh', title: '薄荷英语干货铺公众号' },
            { value: 'mint_journal_gzh', title: '薄荷外刊公众号' },
            { value: 'cya_gzh', title: '超有爱课堂公众号' },
            { value: 'bcz_app', title: '百词斩APP' },
            { value: 'yq_app', title: '夜曲APP' },
            { value: 'mint_app', title: '薄荷阅读APP' },
            { value: 'pie_app', title: '芝士派APP' },
            { value: 'egg_app', title: '咸蛋APP' },
            { value: 'tomato_app', title: '番茄APP' },
            { value: 'cheeseup_app', title: '芝士小考APP' },
            { value: 'danny_listening_app', title: '丹尼每日听力APP' },
        ] },
    { value: 'baicizhan', title: '百词斩', 
        children: [
            { value: 'app.baicizhan', title: '百词斩APP' },
            { value: 'app.ireading', title: '爱阅读' },
            { value: 'app.magic', title: '神奇辅导' },
            { value: 'wechat.baicizhan', title: '百词斩微信h5' },
        ] },
    { value: 'nocturne', title: '夜曲', 
        children: [
            { value: 'nocturne', title: '夜曲编程' },
        ] },
    { value: 'college-math', title: '大学数学', 
        children: [
            { value: 'college-math', title: '大学数学' },
        ] },
    { value: 'adult-english', title: '成人英语', 
        children: [
            { value: 'nce2', title: '新概念英语2册(' }
        ] },
    { value: 'datap', title: '数据中台',
        children: [
            { value: 'datap-web', title: '数据中台' },
        ] },
    { value: 'ywzt', title: '业务中台',
        children: [
            { value: 'crm', title: 'CRM系统' },
        ] },
    { value: 'tech', title: '技术中台',
        children: [
            { value: 'tech', title: '技术中台' },
        ] },
];

const apps = [];

for (let project of projects) {
    for (let app of project.children) {
        apps.push(app)
    }
}

const eventTypes = [
    { value: 'imp', title: '曝光事件' },
    { value: 'click', title: '点击事件' },
    { value: 'page_view', title: '页面浏览事件' },
    { value: 'app_install', title: 'APP安装事件' },
    { value: 'app_start', title: 'APP启动事件' },
    { value: 'first_visit', title: '首次访问事件' },
    { value: 'add_cart', title: '加购事件' },
    { value: 'order', title: '下单事件' },
    { value: 'pay', title: '支付事件' },
    { value: 'page_stay', title: '页面停留事件' },
    { value: 'regist', title: '注册事件' },
    { value: 'logic', title: '逻辑埋点' },
    { value: 'custom_event', title: '自定义事件' },
];

const userTagsCategoryInfos = [
    {
        title: '基本信息',
        key: '基本信息',
        children: [
            {
                title: '人口统计',
                key: '人口统计'
            }, {
                title: '教育信息',
                key: '教育信息'
            }, {
                title: '设备账号',
                key: '设备账号'
            },
        ]
    }, {
        title: '地理位置',
        key: '地理位置',
        children: [
            {
                title: '生活坐标',
                key: '生活坐标'
            }, {
                title: 'LBS周边',
                key: 'LBS周边'
            }
        ]
    }, {
        title: '行为习惯',
        key: '行为习惯',
        children: [
            {
                title: '交易行为',
                key: '交易行为'
            }, {
                title: '流程行为',
                key: '流程行为'
            }, {
                title: '课程学习行为',
                key: '课程学习行为'
            }, {
                title: '背单词行为',
                key: '背单词行为'
            }
        ]
    }, {
        title: '学习能力',
        key: '学习能力',
        children: [
            {
                title: '英语水平',
                key: '英语水平'
            }
        ]
    }, {
        title: '资信能力',
        key: '资信能力',
        children: [
            {
                title: '能力价值',
                key: '能力价值'
            }
        ]
    }, {
        title: '关系社交',
        key: '关系社交',
        children: [
            {
                title: '社交能力',
                key: '社交能力'
            }
        ]
    }, {
        title: '需求意愿',
        key: '需求意愿',
        children: [
            {
                title: '学习意愿',
                key: '学习意愿'
            }, {
                title: '学习需求',
                key: '学习需求'
            }
        ]
    }, {
        title: '兴趣偏好',
        key: '兴趣偏好',
        children: [
            {
                title: '购物偏好',
                key: '购物偏好'
            }, {
                title: '兴趣爱好',
                key: '兴趣爱好'
            }
        ]
    }
];

const userTagsBaseFields = [
    {
        title: '标签名称',
        kind: 'INPUT',
        index: 'name',
        required: true,
    }, {
        title: '业务逻辑描述',
        kind: 'TEXT_AREA',
        index: 'bizDesc',
        required: true,
    }, {
        title: '字段名',
        kind: 'INPUT',
        index: 'fieldName',
        required: true,
    }, {
        title: '表名',
        kind: 'INPUT',
        index: 'tableName',
        required: true,
    }, {
        title: '枚举值',
        kind: 'INPUT',
        index: 'enumValues',
        required: false,
    }, {
        title: '对象',
        kind: 'SELECT',
        index: 'objectKind',
        options: [{
            title: '用户',
            key: '用户'
        }, {
            title: '销售',
            key: '销售'
        }, {
            title: '课程',
            key: '课程'
        }],
        required: true,
    }, {
        title: '产出时效',
        kind: 'SELECT',
        index: 'timeKind',
        options: [
            {
                title: '离线',
                key: '离线'
            }, {
                title: '实时',
                key: '实时'
            }
        ],
        required: true,
    }, {
        title: '加工类型',
        kind: 'SELECT',
        index: 'processingKind',
        options: [
            {
                title: '事实',
                key: '事实'
            }, {
                title: '统计',
                key: '统计'
            }, {
                title: '预测',
                key: '预测'
            }
        ],
        required: true,
    }, {
        title: '一级类目',
        kind: 'SELECT',
        index: 'categoryClass1',
        options: userTagsCategoryInfos,
        required: true,
    }, {
        title: '二级类目',
        kind: 'SELECT',
        index: 'categoryClass2',
        options: userTagsCategoryInfos,
        required: true,
    }
];

const samplingConstants = {
    projects,
    apps,
    eventTypes
};

function parseUrlSearch(search) {
    const params = {};
    if (isNotEmpty(search)) {
        const query = search.substring(1);
        
        for(let part of query.split("&")) {
            const segments = part.split('=');
            params[segments[0]] = segments[1];
        }
    }
    return params;
}

function isWindows() { 
    return /windows|win32/i.test(navigator.userAgent);
}

function isTimeFormat(format) {
    switch (format) {
        case 'IDENTITY':
        case 'SEX':
        case 'YES_OR_NO':
        case 'PROVINCE':
        case 'CITY':
        case 'CITY_LEVEL':
        case 'DEVICE_KIND':
        case 'DEVICE_PRICE':
        case 'USER_GRADE':
        case 'AD_POSITION':
        case 'TO_GROUP':
        case 'FROM_GROUP':
        case 'TO_OBJECT':
        case 'AD_KIND':
        case 'INPUT':
        case 'MULTI_INPUT':
        case 'LIKE_INPUT':
        case 'BCZ_WORD_BOOK':
        case 'BCZ_STAFF_UID':
            return false;
        case 'DATE_RANGE':
            return true;
        default:
            if (format.startsWith('OPTS:')) {
                return false;
            } else {
                return true;
            }
    }
}

export {
    toThousands, hashCode, isEmpty, isNotEmpty, ifEmpty, formatSpaceSize, storageTableExtraInfos, storageLevels, storageBus, storageMarket,
    storageVersionAreas, storageFlattenAreas, storageSpaceSizeColors, getSpaceSizeUnit, dateTimeFormat, dateFormat,
    parseUrlSearch, samplingConstants, isWindows, isTimeFormat, userTagsCategoryInfos, userTagsBaseFields
};